import styled from 'styled-components';

export const TooltipContainer = styled.div`
	position: relative;
	display: inline-block;
`;

export const TooltipTrigger = styled.div`
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
`;

export const TooltipContent = styled.div`
	position: absolute;
	top: calc(100%);
	left: 5.5rem;
	z-index: 9999;
	background-color: rgb(253 253 253);
	color: #262626;
	padding: 10px;
	border-radius: 0 10px 10px 10px;
	border: 1.5px solid #262626;
	font-weight: 600;
	font-size: 14px;
	line-height: 1.5;
	min-width: 180px;
	word-wrap: break-word;
	box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
	backdrop-filter: blur(25px);
	transform: translateX(-50%);
	animation: fadeIn 0.2s ease-in-out;

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateX(-50%) translateY(-4px);
		}
		to {
			opacity: 1;
			transform: translateX(-50%) translateY(0);
		}
	}
`;
